module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var activeClass = active ? '' : 'disabled';;
__p += '\n<button id="' +
((__t = (id)) == null ? '' : __t) +
'" class="btn ' +
((__t = (btnCss)) == null ? '' : __t) +
' ' +
((__t = (activeClass)) == null ? '' : __t) +
'" title="' +
((__t = (title)) == null ? '' : __t) +
'">\n    <div class="' +
((__t = (displayClass)) == null ? '' : __t) +
'"></div>\n</button>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Tool/bootstrap4/templates/NavigationHistory.ejs
// module id = 451
// module chunks = 0